/** Word-level IPA overrides for Vietnamese. */
export const vi: Record<string, string> = {
  chinh: '/tɕɪŋ˧/',
  liêu: '/liəw˧/',
  ngác: '/ŋak˧˥/',
  truân: '/ʈwən˧/',
};
